import SearchableDropdown from '../../../components/SearchableDropdown';
import { profilesForBuild } from '../branding/deviceProfiles';
import { CAPABILITY_ROWS, LEVELS, LEVEL_LABELS, setCapability } from './capabilities';
import type { DeviceCapabilities } from '@platform/shared-types';

interface Props {
  capabilities: DeviceCapabilities;
  installProfileId?: string;
  /** The model's chosen build — only its hardware profiles are offered. */
  buildTarget?: string;
  onChange: (next: { capabilities: DeviceCapabilities; installProfileId?: string }) => void;
}

/** The device profile's hardware: which installer profile, and what peripherals. */
export function CapabilitiesFields({ capabilities, installProfileId, buildTarget, onChange }: Props) {
  return (
    <div className="space-y-3">
      <div>
        <div className="text-[11px] text-gray-400 uppercase tracking-wide mb-1">Hardware profile</div>
        <div className="w-80">
          <SearchableDropdown
            value={installProfileId || null}
            onChange={(v) => onChange({ capabilities, installProfileId: v || undefined })}
            options={profilesForBuild(buildTarget, installProfileId).map((p) => ({ value: p.id, label: p.displayName }))}
            placeholder="Select the hardware…"
            searchPlaceholder="Search hardware…"
          />
        </div>
      </div>
      {CAPABILITY_ROWS.map((row) => (
        <div key={row.key}>
          <div className="text-sm font-medium text-gray-800">{row.label}</div>
          <div className="mt-1 inline-flex rounded-xl border border-gray-200 bg-white p-1 gap-1">
            {LEVELS.map((lvl) => {
              const on = capabilities[row.key] === lvl;
              return (
                <button
                  key={lvl}
                  type="button"
                  onClick={() => onChange({ capabilities: setCapability(capabilities, row.key, on ? null : lvl), installProfileId })}
                  className={`min-h-[44px] px-4 rounded-lg text-sm font-semibold ${on ? 'bg-ruby text-white' : 'text-gray-600 hover:bg-rose-50'}`}
                >
                  {LEVEL_LABELS[lvl]}
                </button>
              );
            })}
          </div>
          <p className="mt-1 text-[11px] text-gray-500">{row.hint}</p>
        </div>
      ))}
    </div>
  );
}
